import React from 'react';

const Header = () => {
	return ( 
		<header className="bg-alert">
			<h1>Drinks Finder</h1>
		</header>
	 );
}
 
export default Header;